import React from 'react';
import PropTypes from 'prop-types';
import { Step } from 'Components';
import './Steps.css';

const Steps = (props) => {
  const steps = [];

  for (let n = 0; n != props.steps.length; n += 1) {
    steps.push(
      <Step
        onClick={() => props.index !== n && props.onClick(n)}
        isDisabled={!(props.maxIndex === undefined || n <= props.maxIndex)}
        isActive={n <= props.maxIndex}
        isCurrent={n === props.index}
        text={props.steps[n]}
        key={n}
      >
        {n + 1}
      </Step>,
    );
  }

  for (let i = steps.length - 1; i > 0; i -= 1) {
    if (i <= props.maxIndex) {
      steps.splice(i, 0, <span key={`l${i}`} className="steps__link steps__link--active" />);
    } else if (i === props.maxIndex + 1 && props.maxIndex === props.index) {
      steps.splice(i, 0, <span key={`l${i}`} className="steps__link steps__link--cusp" />);
    } else {
      steps.splice(i, 0, <span key={`l${i}`} className="steps__link" />);
    }
  }

  return (
    <div className="steps">
      <div>{steps}</div>
    </div>
  );
};

Steps.propTypes = {
  onClick: PropTypes.func,
  index: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.string),
  maxIndex: PropTypes.number,
};

export default Steps;



// WEBPACK FOOTER //
// ./src/components/Steps/Steps.jsx